import React, { ComponentProps } from 'react';
import AdvancedModal from '@tovia/man-ui/lib/components/Modal/AdvancedModal';
import { useSelector } from '../../redux';
import { UpgradeModal } from './UpgradeModal';
import { UpgradeButton } from './UpgradeButton';
import { useJoinUrl } from '../buttons/JoinButton';

type Props = ComponentProps<typeof AdvancedModal>;

export const UpgradeFreeMonthDialog = (props: Props) => {
  const config = useSelector((state) => state.app.config);

  const [joinUrl] = useJoinUrl({
    campaign: 'upgrade-free-month',
    extraParams: {
      promoCode: config.freeMonthUpgradePromo,
    },
  });

  return (
    <UpgradeModal {...props}>
      <p>We&apos;re sorry - your account has expired and downloads have been restricted.</p>
      <p>
        To restore full downloads and receive a FREE month on us, please click below and enjoy your new premium account.
      </p>
      <UpgradeButton url={joinUrl} target="_top">
        Enter Here
      </UpgradeButton>
    </UpgradeModal>
  );
};
